<template>
    <Head title="Dashboard: Пользователи"/>

    <authenticated-layout :notifications="notifications" >

        <v-navigation/>

        <div class="md:p-6">

            <div v-if="success" class="grid grid-cols-1 md:grid-cols-2 gap-6">

                <div class="flex flex-col gap-6">
                    <div class="flex flex-col bg-white rounded p-4">
                        <h1 class="text-lg pb-4">Статистика</h1>
                        <div class="grid grid-cols-5 p-1 border-b text-right">
                            <strong class="col-span-2"></strong><strong>За день</strong>
                            <strong>За неделю</strong><strong>За месяц</strong>
                        </div>

                        <div class="grid grid-cols-5 p-1 text-right" v-if="statistics.registration">
                            <strong class="col-span-2 text-left">Зарегистрировались</strong>
                            <span v-for="interval of statistics.registration">{{ interval.count.total }}</span>
                        </div>
                        <div class="grid grid-cols-5 p-1 text-right bg-gray-100" v-if="statistics.registration">
                            <strong class="col-span-2 text-left">Подтвердили почту</strong>
                            <span v-for="interval of statistics.registration">{{ interval.count.confirm }}</span>
                        </div>

                        <div class="grid grid-cols-5 p-1 text-right" v-if="statistics.orders">
                            <strong class="col-span-2 text-left">Оплаты, количество</strong>
                            <span class="text-right" v-for="interval of statistics.orders">{{ interval.count }}</span>
                        </div>
                        <div class="grid grid-cols-5 p-1 text-right bg-gray-100" v-if="statistics.orders">
                            <strong class="col-span-2 text-left">Оплаты, сумма</strong>
                            <span class="text-right" v-for="interval of statistics.orders">
                                {{ Number(interval.sum).toLocaleString([], {style: 'currency', currency: 'USD'}) }}
                            </span>
                        </div>
                        <div class="grid grid-cols-5 p-1 text-right" v-if="statistics.orders">
                            <strong class="col-span-2 text-left">Оплаты, конверсия</strong>
                            <span class="text-right" v-for="interval of statistics.orders">
                                {{ (!interval.total) ? 0 : Number(interval.count/interval.total).toLocaleString() }}
                            </span>
                        </div>

                        <div class="grid grid-cols-5 p-1 text-right bg-gray-100" v-if="statistics.withdrawal">
                            <strong class="col-span-2 text-left">Выводы, количество</strong>
                            <span class="text-right" v-for="interval of statistics.withdrawal">{{ interval.count }}</span>
                        </div>
                        <div class="grid grid-cols-5 p-1 text-right" v-if="statistics.withdrawal">
                            <strong class="col-span-2 text-left">Выводы, сумма</strong>
                            <span class="text-right" v-for="interval of statistics.withdrawal">
                                {{ Number(interval.sum).toLocaleString([], {style: 'currency', currency: 'USD'}) }}
                            </span>
                        </div>
                        <div class="grid grid-cols-5 p-1 text-right bg-gray-100" v-if="statistics.payments">
                            <strong class="col-span-2 text-left">Выплаты, количество</strong>
                            <span class="text-right" v-for="interval of statistics.payments">{{ interval.count }}</span>
                        </div>
                        <div class="grid grid-cols-5 p-1 text-right" v-if="statistics.payments">
                            <strong class="col-span-2 text-left">Выплаты, сумма</strong>
                            <span class="text-right" v-for="interval of statistics.payments">
                                {{ Number(interval.sum).toLocaleString([], {style: 'currency', currency: 'USD'}) }}
                            </span>
                        </div>

                    </div>
                </div>

                <div class="flex flex-col gap-6">
                    <div class="flex flex-col bg-white rounded p-4" v-if="statistics.registration">
                        <div class="flex justify-between pb-4">
                            <h1 class="text-lg">Новые пользователи</h1>
                            <ul class="flex gap-2">
                                <li class="text-blue-700 font-bold cursor-pointer"
                                    @click="registrationInterval=`day`"
                                    :class="{underline: registrationInterval===`day`}">День</li>
                                <li class="text-blue-700 font-bold cursor-pointer"
                                    @click="registrationInterval=`week`"
                                    :class="{underline: registrationInterval===`week`}">Неделя</li>
                                <li class="text-blue-700 font-bold cursor-pointer"
                                    @click="registrationInterval=`month`"
                                    :class="{underline: registrationInterval===`month`}">Месяц</li>
                            </ul>
                        </div>
                        <div class="grid grid-cols-3 gap-2 border-b">
                            <strong class="col-span-2">Email</strong>
                            <strong class="text-right">Регистрация (UTC)</strong>
                        </div>
                        <div
                            class="grid grid-cols-3 gap-2 p-1"
                            v-for="(user, index) of statistics.registration[registrationInterval]?.list"
                            :class="{'bg-gray-100': index%2}"
                        >
                            <div class="col-span-2 flex gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-6 w-6" :class="user.confirmed ? 'text-green-400' : 'text-red-400'" viewBox="0 0 16 16">
                                    <path v-if="user.confirmed" d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                                    <path v-else d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                </svg>
                                <span class="truncate text-blue-700">
                                    <Link :href="this.route('ocp.user', user.id)">{{ user.email }}</Link>
                                </span>
                            </div>
                            <span class="text-right">{{ moment(user.created_at).utc().format('L LTS') }}</span>
                        </div>
                    </div>

                </div>


            </div>

        </div>

    </authenticated-layout>

</template>

<script>
import {ref} from 'vue';
import moment from 'moment';
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Dashboard';
import VButton from '@/Components/Button';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VButton,
    },
    props: {
        success: Boolean,
        statistics: Object,
        notifications: Array,
    },
    setup () {
        return {
            registrationInterval: ref('day'),
        }
    },
    methods: {
        moment,
        sum(obj, name) {
            let sum = 0;
            for(const i of obj)
                sum += parseFloat(i[name]);
            return Number(sum).toLocaleString();
        },
    },
}
</script>
